export const environment = {
    production: true,
    apiHost: 'https://gamefaceapi.groupworkguru.com',
    uiHost: 'https://gameface.groupworkguru.com',
    cookieDomain: 'groupworkguru.com',


    userPoolClientId: '5t9d28q91mi4r2eph410esq3nk',
    userPoolId: 'ap-southeast-2_cNH7iroNd',
    identityPoolId: "ap-southeast-2:300162df-a40f-49b8-926a-8eb07d052e94",

    awsMqttHost: 'd01668903r7gbv9d8m4er-ats.iot.ap-southeast-2.amazonaws.com',
    awsRegion: 'ap-southeast-2'
}
